(function () {
  const API_URL = 'https://api-us.ugnas.com/api/system/v3/sa/apk';
  const androidtvGoogleLink = 'https://play.google.com/store/apps/details?id=com.ugreen.nasprotv';

  function getLabels(root) {
    return {
      version: root.dataset.labelVersion || 'Version',
      update: root.dataset.labelUpdate || 'Mise à jour',
      size: root.dataset.labelSize || 'Taille',
      download: root.dataset.labelDownload || 'Télécharger',
      androidtvGoogle: root.dataset.labelAndroidtvGoogle || 'Rechercher et télécharger sur Google Play',
      macIntel: root.dataset.labelMacIntel || 'Intel x86',
      macApple: root.dataset.labelMacApple || 'Apple M',
      macDownloadIntel: root.dataset.labelMacDownloadIntel || 'Télécharger Intel x86',
      macDownloadApple: root.dataset.labelMacDownloadApple || 'Télécharger Apple M',
      win32: root.dataset.labelWin32 || 'windows 32-bit',
      win64: root.dataset.labelWin64 || 'windows 64-bit',
      winDownload32: root.dataset.labelWinDownload32 || 'Download 32-bit version',
      winDownload64: root.dataset.labelWinDownload64 || 'Download 64-bit version',
      tv32: root.dataset.labelTv32 || 'TV Client 32-bit',
      tv64: root.dataset.labelTv64 || 'TV Client 64-bit',
      tvDownload32: root.dataset.labelTvDownload32 || 'Download 32-bit version',
      tvDownload64: root.dataset.labelTvDownload64 || 'Download 64-bit version',
      androidtv32: root.dataset.labelAndroidtv32 || 'TV Client(Android) 32-bit',
      androidtv64: root.dataset.labelAndroidtv64 || 'TV Client(Android) 64-bit',
      androidtvDownload32: root.dataset.labelAndroidtvDownload32 || 'Download 32-bit version',
      androidtvDownload64: root.dataset.labelAndroidtvDownload64 || 'Download 64-bit version',
    };
  }

  function returnVerDivFn(data, downloadName, labels) {
    let tipsdiv = `<p><span>${data.scopeApplication}</span></p>`;
    if (data.clientBit == 3) {
      tipsdiv = `<p><span>${data.armScope}</span></p>`;
    }

    return `<div class="ug-download-itempr relative">
      <div class="ug-downloads-getVerifyFn ug-downloads-button" data-pkgUrl="${data.pkgUrl}" data-appNo="${data.appNo}">${downloadName}</div>
      <div class="Version_popup bg-[#fff] px-[16px] py-[16px] min-w-[240px]">
        ${tipsdiv}
        <p><span>${labels.version}: ${data.verName}</span></p>
        <p class="whitespace-nowrap">${labels.update}: ${data.showTime}</p>
        <p class="whitespace-nowrap">${labels.size}: ${data.showSize}M</p>
      </div>
    </div>`;
  }

  function returnLinkDivFn(url, downloadName) {
    return `<div class="ug-download-itempr relative">
      <a class="ug-downloads-button" href="${url}" target="_blank">${downloadName}</a>
    </div>`;
  }

  function appendHtml(selector, html) {
    const container = document.querySelector(selector);
    if (container && html) {
      container.insertAdjacentHTML('beforeend', html);
    }
  }

  function processAppData(appSoftVers, labels) {
    const dataDivList = { windows: '', mac: '', tvClient: '', androidtvClient: '' };

    appSoftVers.forEach((v) => {
      const timestamp = new Date(v.utime);
      const timeMonth = timestamp.getMonth() + 1;
      v.showTime = timestamp.getDate() + '/' + timeMonth + '/' + timestamp.getFullYear();
      v.showSize = (v.size / 1024).toFixed(2);

      if (v.appNo === 'com.ugreenNasPro.mac') {
        const downloadName = dataDivList.mac
          ? v.clientBit == 0
            ? labels.macDownloadIntel
            : v.clientBit == 3
              ? labels.macDownloadApple
              : labels.download
          : v.clientBit == 0
            ? labels.macIntel
            : v.clientBit == 3
              ? labels.macApple
              : labels.download;
        dataDivList.mac += returnVerDivFn(v, downloadName, labels);
      } else if (v.appNo === 'com.ugreenNasPro.win') {
        const downloadName = dataDivList.windows
          ? v.clientBit == 1
            ? labels.winDownload32
            : v.clientBit == 2
              ? labels.winDownload64
              : labels.download
          : v.clientBit == 1
            ? labels.win32
            : v.clientBit == 2
              ? labels.win64
              : labels.download;
        dataDivList.windows += returnVerDivFn(v, downloadName, labels);
      } else if (v.appNo === 'com.ugreen.tvpro.tvos') {
        const downloadName = dataDivList.tvClient
          ? v.clientBit == 1
            ? labels.tvDownload32
            : v.clientBit == 2
              ? labels.tvDownload64
              : labels.download
          : v.clientBit == 1
            ? labels.tv32
            : v.clientBit == 2
              ? labels.tv64
              : labels.download;
        dataDivList.tvClient += returnVerDivFn(v, downloadName, labels);
      } else if (v.appNo === 'com.ugreen.nasprotv.int.official.android') {
        const downloadName = dataDivList.androidtvClient
          ? v.clientBit == 1
            ? labels.androidtvDownload32
            : v.clientBit == 2
              ? labels.androidtvDownload64
              : labels.download
          : v.clientBit == 1
            ? labels.androidtv32
            : v.clientBit == 2
              ? labels.androidtv64
              : labels.download;
        dataDivList.androidtvClient += returnVerDivFn(v, downloadName, labels);
      }
    });

    if (dataDivList.tvClient) {
      dataDivList.androidtvClient += returnLinkDivFn(androidtvGoogleLink, labels.androidtvGoogle);
    }

    appendHtml('.download_box .win_download .ug-download-itemab', dataDivList.windows);
    appendHtml('.download_box .mac_download .ug-download-itemab', dataDivList.mac);
    appendHtml('.download_box .appletv_download .ug-download-itemab', dataDivList.tvClient);
    appendHtml('.download_box .androidtv_download .ug-download-itemab', dataDivList.androidtvClient);
  }

  function init() {
    const root = document.querySelector('[data-ug-app-download-box]');
    if (!root) return;

    const labels = getLabels(root);

    fetch(API_URL, {
      method: 'GET',
      headers: {
        'Accept-Language': 'en-US',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.data?.appSoftVers?.length) {
          processAppData(data.data.appSoftVers, labels);
        }
      })
      .catch((error) => {
        console.error('ug-app-download-box:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
